import React from 'react'
import { useSelector } from 'react-redux'
import Badge from '@mui/material/Badge'
import Tooltip from '@mui/material/Tooltip'
import Avatar from '../../../avatar/Avatar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import TextEllipsis from '../../../text/TextEllipsis'

const UserSessionInfo = () => {
  const user = useSelector(state => state?.session?.user || {})

  return (
    <div className='flex justify-end items-center gap-2 px-2 border-x min-w-230px max-w-230px'>
      <div className='min-w-120px max-w-150px'>
        <TextEllipsis
          id={`session-${user.id}`}
          className='font-bold text-right text-sm'
        >
          {user.fullName}
        </TextEllipsis>
        <TextEllipsis
          id={`session-${user.id}-roles`}
          className='text-right text-xs'
        >
          {user?.roles?.map((item) => item.name).join(', ')}
        </TextEllipsis>
      </div>
      { user.isImpersonate ?
        <Tooltip
          arrow
          placement='top'
          title='User impersonate'
        >
          <Badge
            overlap="circular"
            badgeContent={
              <FontAwesomeIcon 
                className='size-4 p-1 rounded-full' 
                icon={['far','sunglasses']} 
                style={{
                  backgroundColor: 'var(--accent)',
                  color: '#fff',
                }} 
              />
            }
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            
          >
            <Avatar 
              size="chart" 
              style={{
                border: '3px solid var(--accent)'
              }} 
              alt={user.code} 
              src={`photos/${user.photo}`} 
              />
          </Badge>
        </Tooltip> :
        <Avatar size="chart" alt={user.code} src={`photos/${user.photo}`} />
      }
    </div>
  )
}

export default UserSessionInfo